import { render, staticRenderFns } from "./CsonakszallitoProduct.vue?vue&type=template&id=ba0ea202&scoped=true&"
import script from "./CsonakszallitoProduct.vue?vue&type=script&lang=js&"
export * from "./CsonakszallitoProduct.vue?vue&type=script&lang=js&"
import style0 from "./CsonakszallitoProduct.vue?vue&type=style&index=0&id=ba0ea202&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0ea202",
  null
  
)

export default component.exports